import './header.scss';
import 'select2';
import AOS from 'aos';

export default async () => {
	$( '.ginput_container_select select' ).select2( {
		minimumResultsForSearch: Infinity,
	} );

	// Sticky menu
	$( window ).scroll( function () {
		if ( $( this ).scrollTop() > 80 ) {
			$( '.header' ).addClass( 'header--sticky' );
		} else {
			$( '.header' ).removeClass( 'header--sticky' );
		}
	} );

	// Menu-list
	$( '.header__menu-list > li > .header' ).parent( 'li' ).addClass( 'has-children' );
	$( '.js-toggle-menu' ).click( function ( e ) {
		e.preventDefault();
		$( 'body' ).toggleClass( 'is-menu-open' );
	} );
	$( '.header__menu > ul > li > ul, .header__menu > ul > li > ul > li > ul' ).parent( 'li' ).addClass( 'has-children' );

	$( '.header__menu > ul > .has-children > a' ).append().after( '<span class=\'header__arrow hide-for-xlarge js-menu-toggle\'><i class=\'icon-arrow-down\'></i></span>' );
	$( '.js-menu-toggle' ).click( function ( e ) {
		e.preventDefault();
		let $this = $( this );

		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.js-menu-toggle' ).removeClass( 'is-active' );
			$this.parent().parent().find( '.has-children ul' ).slideUp( 350 );
			$this.toggleClass( 'is-active' );
			$this.next().slideToggle( 350 );
		}
	} );

	// Footer sticky
	setTimeout( function () {
		$( '.wrapper' ).css( 'margin-bottom', function () {
			return $( '.footer' ).outerHeight();
		} );
	}, 100 );

	AOS.init( {
		once: true,
		duration: 1000,
	} );
	let scrollRef = 0;

	window.addEventListener( 'scroll', function () {
		scrollRef <= 10 ? scrollRef++ : AOS.refresh();
	} );

	// Btn js-scroll
	$( '.js-scroll' ).click( function ( e ) {
		e.preventDefault();
		let target = $( $( this ).attr( 'href' ) );

		if ( target.length ) {
			let scrollTo = target.offset().top - 50;

			$( 'body, html' ).animate( {
				scrollTop: `${scrollTo}px`,
			}, 1000 );
		}
	} );

	// Letter scroll
	letterCarousel( '.js-text-scroll', '.big-title' );

	function letterCarousel ( parent, child ) {
		let e = $( `${parent} ${child}` );

		$( window ).on( 'scroll', function () {
			if ( $( parent ).length ) {
				let n = $( parent ).offset().top;
				let i = $( document ).scrollTop() - n + $( window ).height();
				let scroll = i - 550;
				let scrollSlow = scroll + ( ( scroll / 70 ) / 100 );
				let imgScroll = scrollSlow * -.9;

				e.css( {
					transform: `translateX(${imgScroll}px)`,
				} );
			}
		} );
	}
};
